import React, { useEffect, useState } from "react";
import dashboardclasses from "../../dashboard.module.css";
import { IoClose } from "react-icons/io5";
import { useForm } from "react-hook-form";
import { Services } from "../../../Services";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import Layout from "../../../Components/Layout/layout";

import { css } from "@emotion/react";
import ScaleLoader from "react-spinners/ScaleLoader";
import {
    ToastError,
    ToastSuccess,
} from "../../../Components/utils/ToastMessage";
import {
    validateNegativeValues,
    validateEmptySpaces,
} from "../../../Components/utils/validations";
const override = css`
        display: block;
        margin: 0 auto;
        border-color: red;
    `;
function Warehouse() {
    const Navigate = useNavigate();
    const [CategoryItems, setCategoryItems] = useState({});
    const [loading, setLoading] = useState(true);
    const token = { Authorization: `token ${sessionStorage.getItem("token")}` };
    const {
        register,
        handleSubmit,
        reset,
        formState: { errors },
    } = useForm();

    const getcategories = () => {
        Services.MobilityConfig("GET", null, token)
            .then((res) => {
                if (res.Status === 1) {
                    setCategoryItems(res.Config);
                    reset({
                        ...res.Config,
                    });
                    setLoading(false);
                } else if (res.Status === 0) {
                    ToastError(res.Message);
                    if (res.Message === "Token expired") {
                        Navigate("/");
                    }
                }
            })
            .catch((err) => {
                // alert(err);
                alert("something went wrong please try again");
                console.log(err);
                setLoading(false);
            });
    };
    useEffect(() => {
        getcategories();
    }, []);
    const onSubmit = (data) => {
        setLoading(true);
        let form_Data = { ...data };
        Services.MobilityConfiguPDATE(
            "PATCH",
            JSON.stringify(form_Data),
            token,
            CategoryItems?.id
        )
            .then((res) => {
                if (res.Status === 1) {
                    getcategories();
                    toast.success(`${res.Message}`, {
                        position: "top-center",
                        autoClose: 1000,
                        hideProgressBar: true,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                    });
                } else if (res.Status === 0) {
                    toast.error(`${res.Message}`, {
                        position: "top-center",
                        autoClose: 1000,
                        hideProgressBar: true,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                    });
                }
            })
            .catch((error) => {
                setLoading(false);
                alert("something went wrong please try again");
                console.log(error);
            });
    };
    return (
        <>
            <Layout Active={"config-mobility"}>
                <div className={dashboardclasses["dashboard-rightside"]}>
                    <div className={dashboardclasses.CategoryWrapper}>
                        <h3>Config</h3>

                        {loading ? (
                            <div className={dashboardclasses["loader"]}>
                                <ScaleLoader
                                    color={"black"}
                                    loading={true}
                                    css={override}
                                    size={150}
                                />
                            </div>
                        ) : (
                            <>
                                {/* <div
                                    className={
                                        dashboardclasses["category-form-two"]
                                    }>
                                    <input
                                        type={"text"}
                                        placeholder="search by Coupon Code"
                                        onChange={searchHandler}
                                    />

                                    <button onClick={categoryHandler}>
                                        + Add Coupon
                                    </button>
                                </div> */}
                                <form
                                    className={dashboardclasses["add-items"]}
                                    onSubmit={handleSubmit(onSubmit)}>
                                    <div
                                        className={
                                            dashboardclasses[
                                                "item-image-upload"
                                            ]
                                        }>
                                        <label htmlFor="categoryname">
                                            Admin Fee
                                        </label>
                                        <div
                                            className={
                                                dashboardclasses["select"]
                                            }>
                                            <input
                                                type="number"
                                                step={0.001}
                                                {...register("admin_fee", {
                                                    required:
                                                        "Admin Fee is required",
                                                    validate:
                                                        validateEmptySpaces,
                                                })}
                                            />
                                            {errors?.admin_fee && (
                                                <p
                                                    className={
                                                        dashboardclasses[
                                                            "error"
                                                        ]
                                                    }>
                                                    {errors?.admin_fee?.message}
                                                </p>
                                            )}
                                        </div>
                                    </div>

                                    {/* <div className={dashboardclasses["item-image-upload"]}>
                        <label htmlFor="category">Coupon Image</label>

                        <FileUploader
                            classes={dashboardclasses["upload-image"]}
                            multiple={false}
                            handleChange={handleChange}
                            name="file"
                            children={fileuploadDesign}
                            // types={fileTypes}
                        />
                    </div> */}

                                    <div
                                        className={
                                            dashboardclasses[
                                                "item-image-upload"
                                            ]
                                        }>
                                        <label htmlFor="categoryName">
                                            Distace Limit
                                        </label>
                                        <div
                                            className={
                                                dashboardclasses["select"]
                                            }>
                                            <input
                                                type="number"
                                                {...register(
                                                    "editDistanceLimit",
                                                    {
                                                        required:
                                                            "Distance Limit is required",
                                                        validate:
                                                            validateNegativeValues,
                                                    }
                                                )}
                                            />

                                            {errors?.editDistanceLimit && (
                                                <p
                                                    className={
                                                        dashboardclasses[
                                                            "error"
                                                        ]
                                                    }>
                                                    {
                                                        errors
                                                            ?.editDistanceLimit
                                                            ?.message
                                                    }
                                                </p>
                                            )}
                                        </div>
                                    </div>

                                    <div
                                        className={
                                            dashboardclasses[
                                                "item-image-upload"
                                            ]
                                        }>
                                        <label htmlFor="categoryName">
                                            GST
                                        </label>
                                        <div
                                            className={
                                                dashboardclasses["select"]
                                            }>
                                            <input
                                                type="number"
                                                step={0.001}
                                                {...register("gst", {
                                                    required: "GST is required",
                                                    validate:
                                                        validateNegativeValues,
                                                })}
                                            />

                                            {errors?.gst && (
                                                <p
                                                    className={
                                                        dashboardclasses[
                                                            "error"
                                                        ]
                                                    }>
                                                    {errors?.gst?.message}
                                                </p>
                                            )}
                                        </div>
                                    </div>

                                    <div
                                        className={
                                            dashboardclasses[
                                                "item-image-upload"
                                            ]
                                        }>
                                        <label htmlFor="categoryName">
                                            Waiting Time
                                        </label>
                                        <div
                                            className={
                                                dashboardclasses["select"]
                                            }>
                                            <input
                                                type="number"
                                                {...register("waitingTime", {
                                                    required:
                                                        "Waiting Time is required",
                                                    validate:
                                                        validateNegativeValues,
                                                })}
                                            />

                                            {errors?.waitingTime && (
                                                <p
                                                    className={
                                                        dashboardclasses[
                                                            "error"
                                                        ]
                                                    }>
                                                    {
                                                        errors?.waitingTime
                                                            ?.message
                                                    }
                                                </p>
                                            )}
                                        </div>
                                    </div>

                                    <div
                                        className={
                                            dashboardclasses[
                                                "item-image-upload"
                                            ]
                                        }>
                                        <label htmlFor="categoryName">
                                            Waiting Time Amount
                                        </label>
                                        <div
                                            className={
                                                dashboardclasses["select"]
                                            }>
                                            <input
                                                type="number"
                                                {...register(
                                                    "waitingTimeAmount",
                                                    {
                                                        required:
                                                            "Waiting Time amount is required",
                                                    }
                                                )}
                                            />

                                            {errors?.waitingTimeAmount && (
                                                <p
                                                    className={
                                                        dashboardclasses[
                                                            "error"
                                                        ]
                                                    }>
                                                    {
                                                        errors
                                                            ?.waitingTimeAmount
                                                            ?.message
                                                    }
                                                </p>
                                            )}
                                        </div>
                                    </div>
                                    <div
                                        className={
                                            dashboardclasses[
                                                "item-image-upload"
                                            ]
                                        }>
                                        <label htmlFor="categoryName">
                                            Payment Qr
                                        </label>
                                        <div
                                            className={
                                                dashboardclasses["select"]
                                            }>
                                            <input
                                                type="text"
                                                {...register("paymentQR", {
                                                    required:
                                                        "Payment QR is required",
                                                })}
                                            />

                                            {errors?.paymentQR && (
                                                <p
                                                    className={
                                                        dashboardclasses[
                                                            "error"
                                                        ]
                                                    }>
                                                    {errors?.paymentQR?.message}
                                                </p>
                                            )}
                                        </div>
                                    </div>
                                    <div
                                        className={
                                            dashboardclasses[
                                                "item-image-upload"
                                            ]
                                        }>
                                        <label htmlFor="categoryName">
                                            Youtube Guide
                                        </label>
                                        <div
                                            className={
                                                dashboardclasses["select"]
                                            }>
                                            <input
                                                type="text"
                                                {...register("youtubeGuide", {
                                                    required:
                                                        "Youtube guide is required",
                                                })}
                                            />

                                            {errors?.youtubeGuide && (
                                                <p
                                                    className={
                                                        dashboardclasses[
                                                            "error"
                                                        ]
                                                    }>
                                                    {
                                                        errors?.youtubeGuide
                                                            ?.message
                                                    }
                                                </p>
                                            )}
                                        </div>
                                    </div>
                                    <div
                                        className={
                                            dashboardclasses[
                                                "item-image-upload"
                                            ]
                                        }>
                                        <label htmlFor="categoryName">
                                            Signup video
                                        </label>
                                        <div
                                            className={
                                                dashboardclasses["select"]
                                            }>
                                            <input
                                                type="text"
                                                {...register("signupVideo", {
                                                    required:
                                                        "signup Video is required",
                                                })}
                                            />

                                            {errors?.signupVideo && (
                                                <p
                                                    className={
                                                        dashboardclasses[
                                                            "error"
                                                        ]
                                                    }>
                                                    {
                                                        errors?.signupVideo
                                                            ?.message
                                                    }
                                                </p>
                                            )}
                                        </div>
                                    </div>

                                    <div
                                        className={dashboardclasses["add-btn"]}>
                                        <button
                                            type="submit"
                                            className={
                                                dashboardclasses[
                                                    "add-category-btn"
                                                ]
                                            }>
                                            update
                                        </button>
                                    </div>
                                </form>
                            </>
                        )}
                    </div>
                </div>
            </Layout>
        </>
    );
}

export default Warehouse;
